export enum UserTimezone {
    CET = 1,
    UTC = 2
}